// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"d958c797","36":"6e28b593","211":"589b82dc","581":"0571b5d1","634":"5269f9e8","938":"f87ee688","969":"5adba39e"}[chunkId] + ".chunk.css";
};